import { supabase } from '../lib/supabase';

export type LogAction =
  | 'generate_ideas'
  | 'expand_idea'
  | 'select_idea'
  | 'delete_idea'
  | 'regenerate_idea'
  | 'rewrite_idea'
  | 'generate_artifact'
  | 'edit_artifact'
  | 'delete_artifact'
  | 'update_project_name';

export async function logUserAction(
  projectId: string,
  userId: string,
  action: LogAction,
  details?: Record<string, any>
) {
  try {
    const { error } = await supabase.from('logs').insert({
      project_id: projectId,
      user_id: userId,
      action,
      details
    });

    if (error) {
      console.error('Error logging user action:', error);
    }
  } catch (error) {
    console.error('Error logging user action:', error);
  }
}
